<!--
 * @Description: 
 * @Author: Lidya
 * @Date: 2022-11-14 10:42:58
 * @LastEditors: Lidya
 * @LastEditTime: 2023-01-10 10:07:55
-->
<template>
  <div id="lex-app">
    <router-view></router-view>
           <!-- <div id="pic">
<a href="https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-2500.jpg" 
    data-pswp-width="1669" 
    data-pswp-height="2500" 
    target="_blank">
    <img src="https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-200.jpg" alt="" />
  </a>
  <a href="https://cdn.photoswipe.com/photoswipe-demo-images/photos/7/img-2500.jpg" 
    data-pswp-width="1875" 
    data-pswp-height="2500" 
    data-cropped="true" 
    target="_blank">
    <img src="https://cdn.photoswipe.com/photoswipe-demo-images/photos/7/img-200.jpg" alt="" />
    Cropped
  </a>
</div> -->
  </div>
  
</template>

<script>
/*
Copyright 2017-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/

/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
import Vue from "vue";
import Vuex from "vuex";
import Vuetify from "vuetify";
import "@/components/iconstyle.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons/iconfont/material-icons.css";
import "vuetify/dist/vuetify.min.css";
import "viewerjs/dist/viewer.css";
import { Loader as LexWebUi } from "@/lex-web-ui";
// import VConsole from "vconsole";
import { Swipe, SwipeItem, PullRefresh, ImagePreview, Loading, Popup  } from 'vant';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './components/swiper.css'
Vue.use(VueAwesomeSwiper)
// import 'swiper/dist/css/swiper.css'
// import request from './utils/request'
// localStorage.setItem('vConsole_switch_y', window.innerHeight / 2 + '');
// new VConsole();

Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(PullRefresh)
Vue.use(ImagePreview);
Vue.use(Loading);
Vue.use(Popup);
// Vue.use(VueAwesomeSwiper);

const lexWebUi = new LexWebUi();

export default {
  name: "lex-app",
  store: lexWebUi.store,
  // created() {
  //   request({
  //     method:'POST',
  //     url:'/save',
  //     params:{content:'111',timeStamp:'world', timeZone: '+8'},
  //   })

  // }
  created() {
    
  },
  mounted() {

  }

};
</script>

<style scoped>
#lex-app {
  margin-top: 0vw;
}

/* /deep/ body {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: constant(safe-area-inset-left);
    padding-left: env(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
    padding-right: env(safe-area-inset-right);
} */

/deep/ body {
    -webkit-overflow-scrolling: touch;
}


</style>
